<template lang="pug">
  footer.footer.has-background-light.has-text-centered
    nav.columns.is-multiline.has-background-primary
      .column.is-half-tablet.is-one-quarter-desktop(v-for="item in footerConfig.links")
        p.level-item.has-text-centered
          a.has-text-white(v-if="typeof item.url === 'string'", :href="item.url", target="_blank") {{item.label}}
          router-link.has-text-white(v-else :to="item.url", target="_blank") {{item.label}}
    #browser-supports
      //-p.has-background-primary 《ブラウザ動作環境》
      .field.is-grouped.is-grouped-centered.is-grouped-multiline
        .control
          span(class="tags has-addons")
            span(class="tag is-dark")
              b-icon(pack="fab" icon="edge" size="is-small")
              | &nbsp;&nbsp;Edge
            span(class="tag is-info") 最新
        .control
          span(class="tags has-addons")
            span(class="tag is-dark")
              b-icon(pack="fab" icon="internet-explorer" size="is-small")
              | &nbsp;&nbsp;IE
            span(class="tag is-info") 11以上
        .control
          span(class="tags has-addons")
            span(class="tag is-dark")
              b-icon(pack="fab" icon="chrome" size="is-small")
              | &nbsp;&nbsp;Chrome
            span(class="tag is-info") 最新
        .control
          span(class="tags has-addons")
            span(class="tag is-dark")
              b-icon(pack="fab" icon="firefox" size="is-small")
              | &nbsp;&nbsp;FireFox
            span(class="tag is-info") 最新
        .control
          span(class="tags has-addons")
            span(class="tag is-dark")
              b-icon(pack="fab" icon="safari" size="is-small")
              | &nbsp;&nbsp;Safari
            span(class="tag is-info") 最新

    p#copyright(v-html="footerConfig.copyrightHtml")
</template>

<script>
import {footer as footerConfig} from '@/data/config'
export default {
  name: 'AppFooter',
  data () {
    return {
      footerConfig: footerConfig
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  footer > nav {
    margin: -3rem -1.5rem;
    padding: 2rem 1.5rem;
  }
  footer > nav a:hover {
    /*background-color: #2b4490;*/
    text-decoration: underline;
  }
  #browser-supports {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  #browser-supports > p {
    position: relative;
    line-height: 2rem;
    margin-bottom: .5rem;
  }
  #browser-supports > p:before {
    content: '';
    width: calc(100% - 3rem);
    height: 1px;
    position: absolute;
    background-image: linear-gradient(
        90deg,
        hsla(0, 0%, 100%, 1),
        hsla(0, 0%, 100%, 0) 40%,
        hsla(0, 0%, 100%, 0) 60%,
        hsla(0, 0%, 100%, 1) 100%);
    top: 1rem;
    left: 1.5rem;

  }
  #copyright {
    font-size: .8rem;
    letter-spacing: .1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/TheFooter.vue